const validationHelper = {

    emailIsValid(email) {
        if (email !== undefined && email !== null) {
            const e = email.trim();
            return e.length > 5 && e.includes("@") && e.includes(".") && e.length - e.indexOf(".") > 2
        } else return true
    }
};

export default validationHelper;